const Spinner = () => {
  return (
    <div className="d-flex justify-content-center spinner">
      <div className="spinner-container">
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    </div>
  );
};

export default Spinner;
